import { getMyAvailabilityConstants } from 'src/redux/actions/constant';

const {
  GET_LIST_OF_THERAPIST_AVA_REQUEST,
  GET_LIST_OF_THERAPIST_AVA_SUCCESS,
  GET_LIST_OF_THERAPIST_AVA_FAILURE,
  GET_LIST_OF_THERAPIST_AVA_LOADING,
  GET_LIST_OF_THERAPIST_AVA_RESET,
} = getMyAvailabilityConstants;

const intialState: object = {
  response: null,
  isGetAvailability: false,
  data: [],
  loading: false,
};

export const getListOfTherapistAvaiReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_LIST_OF_THERAPIST_AVA_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isGetAvailability: true,
        data: action.payload.data,
        loading: false,
      };
    }
    case GET_LIST_OF_THERAPIST_AVA_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isGetAvailability: false,
        loading: false,
      };
    }

    case GET_LIST_OF_THERAPIST_AVA_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_LIST_OF_THERAPIST_AVA_RESET:
      return intialState;

    default:
      return state;
  }
};
